module.exports = __webpack_public_path__ + "static/media/mo.157bc9e3.svg";